'use strict';

var _ = require('lodash');
var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;
var SyncMixin = require('../../core/mixins/Sync');

var definition = {
  name: ':name',
  basePath: ':basePath',
  endpoint: 'data_exports',
  debug: false,
  relations: {
    belongsTo: {
      User : {
        localField: 'user',
        localKey: 'userId'
      }
    }
  },
  methods: null
};

var DataExportResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

function getResourceOptions (options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'DataExport',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {},

    // definition to be formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri,
        name: 'DataExport'
      }
    },

    // group: true,

    // hooks to be passed to js-data DS
    hooks: {},

    // model methods to be passed to js-data DS and attached to every model
    modelMethods: _.extend({}, SyncMixin),

    // sync trigger definitions
    // the model trigger definitions will be initiliazed and attached to every collection model
    syncTriggers: {
      collection: [],

      // when the sync listeners are attached, any `:modelId` placeholder will be replaced
      // automatically with the actual id of the model the listener is being initialized for
      model: [{
        type: 'firebase',
        basePath: options.fbBaseUri,
        endpoint: 'data_exports/:modelId/updatedAt',
        token: options.fbAuthToken
      }]
    }
  };
}

module.exports = DataExportResource;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/dataExport/DataExportResource.js